import React from 'react';

const CrmMetricCard = ({ accent, helper, helperText, icon, label, value }) => (
    <article className='ui-kpi has-accent' style={{ '--ui-kpi-accent': accent, '--ui-kpi-helper': helper }}>
        <div className='ui-kpi-head'>
            <span className='ui-eyebrow'>{label}</span>
            <span className='ui-kpi-avatar'>{icon}</span>
        </div>
        <strong className='ui-kpi-value' title={value}>{value}</strong>
        <small className='ui-kpi-foot has-helper-color' title={helperText}>{helperText}</small>
    </article>
);

export default CrmMetricCard;
